import { Type } from 'class-transformer';
import { PersonDto } from './person.dto';

export class CreateNotificationDto {
  message: string;

  @Type(() => Number)
  managerId: number;
}

export class NotificationsInfoDto {
  @Type(() => Number)
  count: number;

  items: NotificationDto[];
}

export class NotificationDto extends CreateNotificationDto {
  @Type(() => Number)
  id: number;

  @Type(() => Date)
  createdAt: Date;

  isRead: boolean;

  manager: PersonDto;
}
